import { Navigate, useLocation } from 'react-router-dom';
import { ServiceSeoLanding } from '../components/ServiceSeoLanding';
import { getServicePageContent } from '../seo/service-pages';
import { SERVICE_SLUG_BY_PATH } from '../seo/static-routes';

export function ServiceSeoPage() {
  const { pathname } = useLocation();
  const slug = SERVICE_SLUG_BY_PATH[pathname];

  if (!slug) return <Navigate to="/services" replace />;

  const content = getServicePageContent(slug);
  if (!content) return <Navigate to="/services" replace />;

  return <ServiceSeoLanding content={content} />;
}
